import styled from '@emotion/styled'
import React from 'react'
import {
    PRIMARY_FONT_CSS_VAR,
    PRIMARY_PAGE_FILL_COLOR_VAR,
    PRIMARY_PAGE_TEXT_COLOR_VAR,
} from '../../context/CustomizationContextProvider'
import { scaledFontSize } from '../../style/scrollingLayout'

const FooterContainer = styled.div({
    // 24px vertical margin, 16px horizontal on mobile
    margin: '24px 16px',
    textAlign: 'center',
    fontSize: scaledFontSize(12),
    fontFamily: `var(${PRIMARY_FONT_CSS_VAR})`,
    color: `var(${PRIMARY_PAGE_TEXT_COLOR_VAR})`,
    backgroundColor: `var(${PRIMARY_PAGE_FILL_COLOR_VAR})`,
    padding: '10px 0',
})

const LogoImage = styled.img({
    width: '200px',
    textAlign: 'center',
    margin: '0 auto',
})

export const PoweredByFooter: React.FC<{
    displayPoweredByFooter?: boolean
}> = ({ displayPoweredByFooter = true }) => {
    const getImageSrc = () => {
        const prefix = process.env.NEXT_PUBLIC_API_PREFIX || ''
        const poweredByImage = 'images/blackcrow-ai.svg'

        return `${prefix}/${poweredByImage}`
    }

    if (!displayPoweredByFooter) {
        return null
    }

    return (
        <FooterContainer>
            <LogoImage src={getImageSrc()} alt="Black Crow AI" />
        </FooterContainer>
    )
}
